import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    Button,
    Typography,
    Select,
    MenuItem,
    InputLabel,
    Box,
    Switch,
    DialogContentText,
    Tooltip,
    Card,
    CardContent,
    Grid
} from '@material-ui/core';
import Draggable from 'react-draggable';
import TreeItem from '@material-ui/lab/TreeItem';
import SettingsIcon from '@material-ui/icons/Settings';
import DeleteIcon from '@material-ui/icons/Delete';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import Notification from '../components/shared/notification.component';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import { HexColorPicker } from 'react-colorful';
import EdgeOrREST from '../EdgeOrREST';
import { useDispatch } from 'react-redux';
import ResultsTable from './gridResultsTable';

export default function GridEditor(props) {
    const [gridSettingOpen, setGridSettingOpen] = React.useState(false);
    const [settingId, setSettingId] = React.useState(0);
    const [settingGridXStart, setSettingGridXStart] = React.useState(0);
    const [settingGridYStart, setSettingGridYStart] = React.useState(0);
    const [settingGridWidth, setSettingGridWidth] = React.useState(0);
    const [settingGridHeight, setSettingGridHeight] = React.useState(0);
    const [gridName, setGridName] = React.useState("");
    const [color, setColor] = React.useState("#00008B");
    const [selectedStandard, setSelectedStandard] = React.useState('EN13201:2015 Illuminance');
    const [selectedGridClass, setSelectedGridClass] = React.useState('P1');
    const [gridClass, setGridClass] = React.useState(['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'C0', 'C1', 'C2', 'C3', 'C4', 'C5']);
    const [gridYSpacing, setGridYSpacing] = React.useState(null);
    const [gridXSpacing, setGridXSpacing] = React.useState(null);
    const [showName, setShowName] = React.useState(false);
    const [showValues, setShowValues] = React.useState(true);
    const [pointYSpacing, setPointYSpacing] = React.useState(null);
    const [pointXSpacing, setPointXSpacing] = React.useState(null);
    const [pointSpacing, setPointSpacing] = React.useState(false);
    const [edgeStart, setEdgeStart] = React.useState(false);

    const [lavGreaterThan, setLavGreaterThan] = React.useState(null);
    const [reiGreaterThan, setReiGreaterThan] = React.useState(null);
    const [tiLessThan, setTILessThan] = React.useState(null);
    const [u0GreaterThan, setU0GreaterThan] = React.useState(null);
    const [ulGreaterThan, setULGreaterThan] = React.useState(null);
    const [wetU0GreaterThan, setWetU0GreaterThan] = React.useState(null);
    const [eMinGreaterThan, setEMinGreaterThan] = React.useState(null);
    const [eavGreaterThan, setEavGreaterThan] = React.useState(null);
    const [eavLessThan, setEavLessThan] = React.useState(null);
    const [lMaxLMinRatioLessThan, setLMaxLMinRatioLessThan] = React.useState(null);
    const [lavLMinRatioLessThan, setLavLMinRatioLessThan] = React.useState(null);
    const [lvMaxLavRatioLessThan, setLvMaxLavRatioLessThan] = React.useState(null);
    const [ephGreaterThan, setEphGreaterThan] = React.useState(null);
    const [epvGreaterThan, setEpvGreaterThan] = React.useState(null);
    const [ue2LessThan, setUE2LessThan] = React.useState(null);
    const [esGreaterThan, setEsGreaterThan] = React.useState(null);
    const [ue1LessThan, setUE1LessThan] = React.useState(null);
    const [uwlrLessThan, setUWLRLessThan] = React.useState(null);


    function getResultsTable(grid) {
        if (props.gridResults && props.gridResults[grid.id] && props.gridResults[grid.id].calcResults) {
            return <ResultsTable id={grid.id} name={grid.name} standard={grid.gridStandard} results={props.gridResults[grid.id].calcResults}
                variables={{
                    lavGreaterThan,
                    reiGreaterThan,
                    tiLessThan,
                    u0GreaterThan,
                    ulGreaterThan,
                    wetU0GreaterThan,
                    eMinGreaterThan,
                    eavGreaterThan,
                    eavLessThan,
                    lMaxLMinRatioLessThan,
                    lavLMinRatioLessThan,
                    lvMaxLavRatioLessThan,
                    ephGreaterThan,
                    epvGreaterThan,
                    ue2LessThan,
                    esGreaterThan,
                    ue1LessThan,
                    uwlrLessThan
                }}
            />;
        }
        return null;
    }

    const handleGridSettingClick = (index) => {
        console.log("called handleGridSettingClick", index, props.grids);
        setSettingId(index);
        setSettingGridXStart(props.grids[index].origin.x.start);
        setSettingGridYStart(props.grids[index].origin.y.start);
        setSettingGridWidth(props.grids[index].origin.x.length);
        setSettingGridHeight(props.grids[index].origin.y.length);
        setGridName(props.grids[index].name);
        setColor(props.grids[index].color);
        setSelectedGridClass(props.grids[index].gridClass);
        setSelectedStandard(props.grids[index].gridStandard);
        setGridXSpacing(props.grids[index].xSpacing);
        setGridYSpacing(props.grids[index].ySpacing);
        setPointXSpacing(Math.floor(props.grids[index].origin.x.length / props.grids[index].xSpacing));
        setPointYSpacing(Math.floor(props.grids[index].origin.y.length / props.grids[index].ySpacing));
        setGridSettingOpen(true);
    };

    const handleGridSettingSave = () => {
        if (settingGridWidth > 0 && settingGridHeight > 0) {
            var tempGrids = props.grids;
            tempGrids[settingId].origin.x.start = settingGridXStart;
            tempGrids[settingId].origin.x.length = settingGridWidth;
            tempGrids[settingId].origin.y.start = settingGridYStart;
            tempGrids[settingId].origin.y.length = settingGridHeight;

            let newYSpacing, newXSpacing;

            if (pointSpacing) {
                newXSpacing = pointXSpacing > 1 ? props.grids[settingId].origin.x.length / pointXSpacing : props.grids[settingId].origin.x.length;
                newYSpacing = pointYSpacing > 1 ? props.grids[settingId].origin.y.length / pointYSpacing : props.grids[settingId].origin.y.length;
            } else {
                newXSpacing = gridXSpacing;
                newYSpacing = gridYSpacing;
            }

            props.updateGridOnSave(settingId, gridName, color, selectedStandard, selectedGridClass, newXSpacing, newYSpacing, showName, edgeStart, showValues);

            setSettingGridHeight(0);
            setSettingGridWidth(0);
            setSettingGridXStart(0);
            setSettingGridYStart(0);
            setGridSettingOpen(false);
        } else {
            props.setSnack({
                open: true,
                message: "Please enter valid dimensions (Width and Height have to be greater than 0)",
                severity: 'warning'
            });
        }
    }

    const onShowGridResults = (index) => {
        const updatedGrid = { ...props.grids[index] };
        updatedGrid.showResults = !updatedGrid.showResults;
        props.updateGridResults(index, updatedGrid.showResults);
    };


    const onSetSettingGridWidth = (e) => {
        setSettingGridWidth(e.target.value);
    }
    const onSetSettingGridHeight = (e) => {
        setSettingGridHeight(e.target.value);
    }
    const onSetSettingGridXStart = (e) => {
        setSettingGridXStart(e.target.value);
    }
    const onSetSettingGridYStart = (e) => {
        setSettingGridYStart(e.target.value);
    }

    const dropbox = [
        'EN13201:2015 Illuminance',
        // 'EN13201:2015 Luminance',
        'BS5489:2020 Illuminance',
        // 'IES RP-8-18',
        'CIE140 Illuminance',
        // 'CIE140 Luminance',
        // 'NZS1158:2005 Cat P Illuminance',
        //'NZS1158:2005 Cat V Luminance',
        // 'AUS Illuminance',
        // 'AUS Luminance',
    ]

    useEffect(() => {
        onStandardChange({ target: { value: 'EN13201:2015 Illuminance' } });
    }, []);

    const onStandardChange = (event) => {
        const standardId = event.target.value;
        setSelectedStandard(standardId);
        let illumTypeId = "Luminance";

        if (standardId.includes("Illuminance")) {
            illumTypeId = "Horizontal";
        }

        EdgeOrREST(null, 'SET_ROAD_CONFIG', onGetStandard, {
            postObject: { standardId, illumTypeId },
        });
    };

    const onGetStandard = (response) => {
        setGridClass(response.data.standard.CalcGridClass);
        setSelectedGridClass(response.data.standard.CalcGridClass[0]);

        const defaultStandards = response.data.standard.DefaultStandards;

        if (defaultStandards) {
            setLavGreaterThan(defaultStandards.LavGreaterThan ?? null);
            setReiGreaterThan(defaultStandards.ReiGreaterThan ?? null);
            setTILessThan(defaultStandards.TILessThan ?? null);
            setU0GreaterThan(defaultStandards.U0GreaterThan ?? null);
            setULGreaterThan(defaultStandards.ULGreaterThan ?? null);
            setWetU0GreaterThan(defaultStandards.WetU0GreaterThan ?? null);
            setEMinGreaterThan(defaultStandards.EMinGreaterThan ?? null);
            setEavGreaterThan(defaultStandards.EavGreaterThan ?? null);
            setEavLessThan(defaultStandards.EavLessThan ?? null);
            setLMaxLMinRatioLessThan(defaultStandards.LMaxLMinRatioLessThan ?? null);
            setLavLMinRatioLessThan(defaultStandards.LavLMinRatioLessThan ?? null);
            setLvMaxLavRatioLessThan(defaultStandards.LvMaxLavRatioLessThan ?? null);
            setEphGreaterThan(defaultStandards.EphGreaterThan ?? null);
            setEpvGreaterThan(defaultStandards.EpvGreaterThan ?? null);
            setUE2LessThan(defaultStandards.UE2LessThan ?? null);
            setEsGreaterThan(defaultStandards.EsGreaterThan ?? null);
            setUE1LessThan(defaultStandards.UE1LessThan ?? null);
            setUWLRLessThan(defaultStandards.UWLRLessThan ?? null);
        }
    };


    const onGridClassChange = (event) => {
        setSelectedGridClass(event.target.value);
        var gridClassId = event.target.value;

        if (selectedStandard.includes("Illuminance")) var illumTypeId = "Horizontal";
        else illumTypeId = "Luminance";

        EdgeOrREST(gridClassId, 'SET_CALC_GRID_CLASS', onGetGridClass, {
            postObject: {
                gridClassId,
                standardId: selectedStandard,
                illumTypeId: illumTypeId
            },
            props: props
        });
    }

    const onGetGridClass = (response) => {
        const defaultStandards = response.data.standard.DefaultStandards;

        if (defaultStandards) {
            setLavGreaterThan(defaultStandards.LavGreaterThan ?? null);
            setReiGreaterThan(defaultStandards.ReiGreaterThan ?? null);
            setTILessThan(defaultStandards.TILessThan ?? null);
            setU0GreaterThan(defaultStandards.U0GreaterThan ?? null);
            setULGreaterThan(defaultStandards.ULGreaterThan ?? null);
            setWetU0GreaterThan(defaultStandards.WetU0GreaterThan ?? null);
            setEMinGreaterThan(defaultStandards.EMinGreaterThan ?? null);
            setEavGreaterThan(defaultStandards.EavGreaterThan ?? null);
            setEavLessThan(defaultStandards.EavLessThan ?? null);
            setLMaxLMinRatioLessThan(defaultStandards.LMaxLMinRatioLessThan ?? null);
            setLavLMinRatioLessThan(defaultStandards.LavLMinRatioLessThan ?? null);
            setLvMaxLavRatioLessThan(defaultStandards.LvMaxLavRatioLessThan ?? null);
            setEphGreaterThan(defaultStandards.EphGreaterThan ?? null);
            setEpvGreaterThan(defaultStandards.EpvGreaterThan ?? null);
            setUE2LessThan(defaultStandards.UE2LessThan ?? null);
            setEsGreaterThan(defaultStandards.EsGreaterThan ?? null);
            setUE1LessThan(defaultStandards.UE1LessThan ?? null);
            setUWLRLessThan(defaultStandards.UWLRLessThan ?? null);
        }
    }

    const onGridSpacingXChange = (e) => {
        setGridXSpacing(e.target.value);
    };

    const onGridSpacingYChange = (e) => {
        setGridYSpacing(e.target.value);
    };

    const toggleNameVisibility = (e) => {
        setShowName(!showName);
    };

    const toggleValueVisibility = (e) => {
        setShowValues(!showValues);
    };

    const onPointSpacingXChange = (e) => {
        setPointXSpacing(e.target.value);
    };

    const onPointSpacingYChange = (e) => {
        setPointYSpacing(e.target.value);
    };


    const togglePointSpacing = (e) => {
        setPointSpacing(!pointSpacing);
    };

    const toggleEdgeStart = (e) => {
        setEdgeStart(!edgeStart);
    };


    return (
        <>

            <Box sx={{ maxHeight: "500px", overflowY: "auto", width: "100%" }}>
                <List>
                    {props.grids.map((grid, index) => (
                        grid.id !== 0 && (
                            <>
                                {/* List Item */}
                                <ListItem key={index} onClick={() => props.selectGrid(grid.id)} style={grid.selected ? { border: "2px solid darkturquoise " } : {}}>
                                    <Tooltip title={grid.name} placement="top">
                                        <ListItemText
                                            primary={
                                                <span
                                                    style={{
                                                        display: "inline-block",
                                                        maxWidth: "150px",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    {grid.name}
                                                </span>
                                            }
                                        />
                                    </Tooltip>

                                    <ListItemSecondaryAction style={{ display: "flex", alignItems: "center" }}>
                                        <IconButton aria-label="setting" style={{ padding: 4 }} onClick={() => handleGridSettingClick(index)}>
                                            <SettingsIcon style={{ fontSize: 24 }} />
                                        </IconButton>
                                        <Tooltip title="Show/Hide Results" placement="top">
                                            <IconButton onClick={() => onShowGridResults(index)} style={{ padding: 4 }}>
                                                {grid.showResults
                                                    ? <AnalyticsIcon style={{ fontSize: 24 }} />
                                                    : <AnalyticsOutlinedIcon style={{ fontSize: 24 }} />
                                                }
                                            </IconButton>
                                        </Tooltip>

                                        <IconButton onClick={() => props.lockGrid(grid.id)} style={{ padding: 4 }}>
                                            {grid.locked ? <LockIcon style={{ fontSize: 24 }} /> : <LockOpenIcon style={{ fontSize: 24 }} />}
                                        </IconButton>
                                        <IconButton aria-label="delete" style={{ padding: 4 }} onClick={() => props.deleteGrid(grid.id)}>
                                            <DeleteIcon style={{ fontSize: 24 }} />
                                        </IconButton>
                                    </ListItemSecondaryAction>
                                </ListItem>

                                {/* Results Table - Rendered below the ListItem if `showResults` is true */}
                                {grid.showResults && (
                                    <Box sx={{ paddingLeft: 2, paddingTop: 1, paddingBottom: 1 }}>
                                        {getResultsTable(grid)}
                                    </Box>
                                )}
                            </>
                        )
                    ))}
                </List>
            </Box>



            <Dialog open={gridSettingOpen}>
                <DialogTitle>Edit Grid</DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px" }}>
                        <TextField
                            label="Grid Name"
                            value={gridName}
                            variant="outlined"
                            name="name"
                            onChange={(e) => setGridName(e.target.value)}
                        />

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Show Name</span>
                            <Switch
                                onChange={(e) => toggleNameVisibility(e)}
                                checked={showName}
                                name="showName"
                                color="primary"
                            />
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Show Values (3D Only)</span>
                            <Switch
                                onChange={(e) => toggleValueVisibility(e)}
                                checked={showValues}
                                name="showValues"
                                color="primary"
                            />
                        </label>
                    </div>

                    <DialogContentText>Set your grid's class</DialogContentText>

                    {/* <TextField
                        style={{ margin: '10px', width: "225px" }}
                        label="Standard"
                        name="calcStandard"
                        onChange={(e) => onStandardChange(e, props)}
                        select
                        SelectProps={{ native: true }}
                        value={selectedStandard}
                        variant="outlined"
                    >
                        {dropbox.map((option) => (
                            <option key={option}>{option}</option>
                        ))}
                    </TextField> */}

                    <TextField
                        style={{ margin: '10px' }}
                        label="Grid Class"
                        name="calcGridClass"
                        onChange={(e) => onGridClassChange(e, props)}
                        select
                        SelectProps={{ native: true }}
                        value={selectedGridClass}
                        variant="outlined"
                    >
                        {gridClass.map((option) => (
                            <option key={option}>{option}</option>
                        ))}
                    </TextField>

                    <DialogContentText>Set your grid spacing</DialogContentText>

                    <div flex="row" style={{ display: "flex", alignItems: "center", gap: "10px", margin: "10px" }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Edge Start</span>
                            <Switch
                                onChange={(e) => toggleEdgeStart(e)}
                                checked={edgeStart}
                                name="showName"
                                color="primary"
                            />
                        </label>

                        <label style={{ display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
                            <span>Point Spacing</span>
                            <Switch
                                onChange={(e) => togglePointSpacing(e)}
                                checked={pointSpacing}
                                name="showName"
                                color="primary"
                            />
                        </label>
                    </div>

                    <div>
                        {!pointSpacing
                            ?
                            <div>
                                <TextField
                                    onChange={(e) => onGridSpacingXChange(e)}
                                    onBlur={() => setGridXSpacing(prev => prev === "" ? 1.5 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Grid X Spacing"}
                                    name="gridXSpacing"
                                    type="number"
                                    value={gridXSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 0.25,
                                        min: 1.5
                                    }}
                                />

                                <TextField
                                    onChange={(e) => onGridSpacingYChange(e)}
                                    onBlur={() => setGridYSpacing(prev => prev === "" ? 1.5 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Grid Y Spacing"}
                                    name="gridYSpacing"
                                    type="number"
                                    value={gridYSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 0.25,
                                        min: 1.5
                                    }}
                                />
                            </div>
                            :
                            <div>
                                <TextField
                                    onChange={(e) => onPointSpacingXChange(e)}
                                    onBlur={() => setPointXSpacing(prev => prev === "" ? 33 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Number of X Points"}
                                    name="pointXSpacing"
                                    type="number"
                                    value={pointXSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 1,
                                    }}
                                />

                                <TextField
                                    onChange={(e) => onPointSpacingYChange(e)}
                                    onBlur={() => setPointYSpacing(prev => prev === "" ? 33 : prev)}
                                    style={{ margin: '10px' }}
                                    label={"Number of Y Points"}
                                    name="pointYSpacing"
                                    type="number"
                                    value={pointYSpacing}
                                    variant="outlined"
                                    inputProps={{
                                        step: 1,
                                    }}
                                />
                            </div>
                        }
                    </div>

                    <DialogContentText>Set your grid dimensions</DialogContentText>
                    <span>
                    <TextField
                        onChange={onSetSettingGridXStart} style={{ margin: '10px' }} label={"X start"} name="xStart" type="number"
                        value={settingGridXStart} variant="outlined"
                        inputProps={{
                            step: 0.25
                        }}
                    />
                    <TextField onChange={onSetSettingGridYStart} style={{ margin: '10px' }} label={"Y start"} name="yStart" type="number"
                        value={settingGridYStart} variant="outlined"
                        inputProps={{
                            step: 0.25
                        }}
                    />
                    </span>
                    <span>
                    <TextField onChange={onSetSettingGridWidth} style={{ margin: '10px' }} label={"Width (m)"} name="xLength" type="number"
                        value={settingGridWidth} variant="outlined"
                        inputProps={{
                            step: 0.25
                        }}
                    />
                    <TextField onChange={onSetSettingGridHeight} style={{ margin: '10px' }} label={"Height"} name="yLength" type="number"
                        value={settingGridHeight} variant="outlined"
                        inputProps={{
                            step: 0.25
                        }}
                    />
                    </span>
                    <DialogContentText>Set grid border color</DialogContentText>
                    <HexColorPicker color={color} onChange={(e) => setColor(e)} style={{ height: "150px" }} />
                    Selected Color: {color}
                </DialogContent>
                <div style={{ textAlign: "right", margin: 10 }}>
                    <Button onClick={handleGridSettingSave} style={{ margin: '10px' }} color="primary" variant="contained"><Typography>Save</Typography></Button>
                    <Button onClick={() => setGridSettingOpen(false)} color="primary" style={{ margin: '10px' }} variant="contained"><Typography>Cancel</Typography></Button>
                </div>
            </Dialog>
        </>
    );
}
